export default "__VITE_ASSET__Bvx4cej0__"